module.exports = {
  map: {
    "[):]": "2022-06-17/1655459510136.png",
    "[:D]": "2022-06-17/1655459553749.png",
    "[;)]": "2022-06-17/1655460123481.png",
    "[:-o]": "2022-06-17/1655460154519.png",
    "[:p]": "2022-06-17/1655460171012.png",
    "[(H)]": "2022-06-17/1655460185377.png",
    "[:@]": "2022-06-17/1655460202942.png",
    "[:s]": "2022-06-17/1655460219010.png",
    "[:$]": "2022-06-17/1655460230702.png",
    "[:(]": "2022-06-17/1655460251483.png",
    "[:'(]": "2022-06-17/1655460268719.png",
    "[:|]": "2022-06-18/1655512466465.png",
    "[(a)]": "2022-06-17/1655460295292.png",
    "[8o|]": "2022-06-17/1655460309990.png",
    "[8-|]": "2022-06-17/1655460323099.png",
    "[+o(]": "2022-06-18/1655512286705.png",
    "[<o)]": "2022-06-17/1655460281085.png",
    "[|-)]": "2022-06-18/1655512479495.png",
    "[*-)]": "2022-06-18/1655512490216.png",
    "[:-#]": "2022-06-18/1655512499636.png",
    "[:-*]": "2022-06-18/1655512522580.png",
    "[^o)]": "2022-06-18/1655512510470.png",
    "[8-)]": "2022-06-18/1655512535840.png",
    "[(|)]": "2022-06-18/1655512553025.png",
    "[(u)]": "2022-06-18/1655512562322.png",
    "[(S)]": "2022-06-18/1655512572441.png",
    "[(*)]": "2022-06-18/1655512586699.png",
    "[(#)]": "2022-06-18/1655512599190.png",
    "[(R)]": "2022-06-18/1655512611075.png",
    "[({)]": "2022-06-18/1655512621537.png",
    "[(})]": "2022-06-18/1655512634928.png",
    "[(k)]": "2022-06-18/1655512647271.png",
    "[(F)]": "2022-06-18/1655512657538.png",
    "[(W)]": "2022-06-18/1655512669597.png",
    "[(D)]": "2022-06-18/1655512679291.png"
  }
};



// WEBPACK FOOTER //
// ./src/utils/emoji.js